import styled from '../../../styles/theme';
import { ModalLeadFormStyled } from '../ModalLeadFormStyled';
import { rem } from 'polished';

export const ModalLeadFormStyledDS = styled(ModalLeadFormStyled)`
    .btn-primary {
        width: 100%;
        padding: ${rem('16px')} ${rem('20px')};
    }
`;
